




























































import { Component, Prop, Mixins} from 'vue-property-decorator';
import {GridNameType} from 'supporter';
import OrderGridsColumns from '@/components/common/order/mixins/OrderGridsColums';
import {i18nInObjectList} from '@/utils/i18n';

@Component({
  name: 'ColumnConfigPopup'
})
export default class ColumnConfigPopup extends Mixins(OrderGridsColumns) {
  @Prop({required: true})
  configOption;

  @Prop({required: true})
  listColumns;

  @Prop({required: true, type: String})
  label!: string;

  private isAllChecked: boolean = false;
  private defaultDisplayOrder: any = [];
  private tmpConfigOption = this.configOption;
  public getGridLayouts: any = [];

  private onDisplaySelected(selected: boolean): void {
    this.tmpConfigOption.forEach(option => {
      if (option.disabled !== true) {
        if (option.checked) {
          option.visible = selected;
        }
      }
    });
  }
  private onDisplayAll(selected: boolean): void {
    this.tmpConfigOption.forEach(option => {
      if (option.disabled !== true) {
        option.visible = selected;
      }
    });
  }

  private onAllCheckChange(value: boolean): void {
    this.tmpConfigOption.forEach(option => {
      option.checked = value;
    });
  }

  private onOrderUp(index: number) {
    let disabledColumns = 0

    this.tmpConfigOption.map((item: any) => {
      if(item.disabled) {
        disabledColumns++
      }
    });
    if (index > disabledColumns) {
      this.onOrderChange(index, -1);
    }
  }
  private onOrderDown(index: number) {
    if (index < this.tmpConfigOption.length - 1) {
      this.onOrderChange(index, 1);
    }
  }
  private onOrderChange(index: number, step: number): void {
    let tmp = {
      name: this.tmpConfigOption[index].name,
      visible: this.tmpConfigOption[index].visible,
      checked: this.tmpConfigOption[index].checked,
      displayName: this.tmpConfigOption[index].displayName
    };

    this.tmpConfigOption[index].name = this.tmpConfigOption[index + step].name;
    this.tmpConfigOption[index].visible = this.tmpConfigOption[index + step].visible;
    this.tmpConfigOption[index].checked = this.tmpConfigOption[index + step].checked;
    this.tmpConfigOption[index].displayName = this.tmpConfigOption[index + step].displayName;
    this.tmpConfigOption[index].order = index + 1;

    this.tmpConfigOption[index + step].name = tmp.name;
    this.tmpConfigOption[index + step].visible = tmp.visible;
    this.tmpConfigOption[index + step].checked = tmp.checked;
    this.tmpConfigOption[index + step].displayName = tmp.displayName;
    this.tmpConfigOption[index + step].order = index + step + 1;
  }

  private doSetting(): void {
    this.tmpConfigOption.forEach(option => {
      option.visible = option.visible.toString() === 'true' ? true : false;
    });
    if (
        this.tmpConfigOption.some(option => {
          return option.visible;
        })
    ) {
      let request = {
        data: {
          gridName: this.gridName(this.label) as GridNameType,
          columns: this.tmpConfigOption.map((column: any) => {
            return {
              columnName: column.name,
              displayOrder: column.order,
              visible: column.visible
            };
          })
        }
      };
      this.$api.putGridLayouts(request).then(() => {
        this.$eventBus.$emit('UPDATE-COLUMN-CONFIG');
        alert(this.getStr('ORDER_LIST_GRIDS_GRID_LAYER_SAVE_MSG'));
        this.doClose();
      });
    } else {
      alert(this.getStr('ORDER_LIST_GRIDS_ALERT_COLUMN_UNVISIBLE_ALL'));
    }
  }
  private doClose(): void {
    this.$eventBus.$emit('LAYER-POP-CLOSE');
  }
  public getColumnName(i18n: string) {
    for(let i=0; i<this.defaultDisplay.length; i++){
      if(this.defaultDisplay[i].i18n === i18n) {
        return this.defaultDisplay[i].columnName
      }
    }
  }
  private doReset(): void {
    this.tmpConfigOption = [];
    this.getGridLayouts.columns = [];
    this.listColumns.map((item: any, index: number): {} => {
      return this.defaultDisplayOrder[index] = {
        columnName: this.getColumnName(item),
        visible: true,
        displayOrder: index
      };
    })
    for (let i = 0; i < this.defaultDisplayOrder.length; i++) {
      this.getGridLayouts.columns[i] = this.getGridRefactory(this.defaultDisplayOrder[i].columnName, this.defaultDisplayOrder[i].visible, this.defaultDisplayOrder[i].displayOrder);
    }
    this.getGridLayouts = i18nInObjectList(window, this.getGridLayouts, 'columns', 'header');
    this.getGridLayouts.columns.forEach(item => {
      let option = {
        name: item.name,
        order: item.order,
        visible: item.visible,
        displayName: item.header,
        disabled: this.getDisabled(item.name)
      };
      this.tmpConfigOption.push(option);
    });
  }

  private getStr(str: string): string {
    return '' + window.$t(str);
  }
}
